<template>
  <div class="container">
    <section class="px-4">
      <span class="section-title mt-4">
        <h1>Blog</h1>
        <h3>
          Confira o conteúdo publicado pelos profissionais
          <br>cadastrados em nosso site
        </h3>
      </span>
      <BlogPosts
        :show-author="true"
        :maxResults=48
        classes="column is-one-third-desktop is-one-quarter-fullhd"
      />
    </section>
  </div>
</template>

<script>
import BlogPosts from '../components/BlogPosts/index'
import { getAllPostsMixin } from '../mixins/posts.methods'
export default {
  components: {
    BlogPosts
  },
  mixins: [getAllPostsMixin]
}
</script>

<style lang="scss" scoped>
</style>
